<ion-item button shareButton="facebook" #fbBtn="shareButton">
  <ion-icon slot="start" name="logo-facebook"></ion-icon>
  <ion-label> Facebook </ion-label>
</ion-item>

<ion-item button shareButton="twitter" #twtBtn="shareButton">
  <ion-icon slot="start" name="logo-twitter"></ion-icon>
  <ion-label> Twitter </ion-label>
</ion-item>

<ion-item button shareButton="email">
  <ion-icon slot="start" name="mail"></ion-icon>
  <ion-label> Email </ion-label>
</ion-item>

<ion-item button shareButton="whatsapp">
  <ion-icon slot="start" name="logo-whatsapp"></ion-icon>
  <ion-label> WhatsApp </ion-label>
</ion-item>

<ion-item button *ngIf="!cordova" (click)="copyLink()">
  <ion-icon slot="start" name="copy-outline"></ion-icon>
  <ion-label> Copy Link </ion-label>
</ion-item>

<ion-item button (click)="dismissPopover()">
  <ion-icon slot="start" name="close-outline"></ion-icon>
  <ion-label> Cancel </ion-label>
</ion-item>
